import React, { Component } from 'react';
import ModalFull from '../../../helpers/ModalFull';
import SelectField from '../../../forms/SelectField';
import { THEME_WHITE } from '../../../../constants/styling/themes';

class PerformanceFiltersMobile extends Component {
    _setFilterArtists = f => this.props.setFilter('artists', f);
    _setFilterStages = f => this.props.setFilter('stages', f);
    _setCategoryFilter = categoryId => selectedLabels => {
        this.props.setCategoryFilter(categoryId, selectedLabels);
    };

    render() {
        const {
            isOpen,
            stagesFilters,
            artistsFilters,
            categoryFilters,
            visibleCategories,
            close,
            stageOptions,
            artistOptions
        } = this.props;

        return (
            <ModalFull className="rp-hidden-1200-plus" open={isOpen} onClose={close}>
                <div className="ckp-events-filter">
                    <div className="ckp-events-filter-title-group">
                        <h2 className="ckp-events-filter-title ckp-ts-h4">Filters</h2>
                    </div>
                    <div className="ckp-grid-row is-responsive-mobile u-margin-left-3">
                        <div className="ckp-grid-column no-margin-first">
                            <SelectField
                                theme={THEME_WHITE}
                                onChange={this._setFilterArtists}
                                items={artistOptions}
                                label="Artist"
                                multiple={true}
                                value={artistsFilters}
                            />
                        </div>
                        <div className="ckp-grid-column">
                            <SelectField
                                theme={THEME_WHITE}
                                onChange={this._setFilterStages}
                                items={stageOptions}
                                label="Stage"
                                multiple={true}
                                value={stagesFilters}
                            />
                        </div>
                    </div>
                    {visibleCategories && visibleCategories.length > 0 && (
                        <div className="ckp-grid-row is-responsive-mobile u-margin-left-3">
                            {visibleCategories.map(category => (
                                <div className="ckp-grid-column" key={category.id}>
                                    <SelectField
                                        theme={THEME_WHITE}
                                        onChange={this._setCategoryFilter(category.id)}
                                        items={category.options}
                                        label={category.label}
                                        multiple={true}
                                        value={categoryFilters[category.id] || []}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </ModalFull>
        );
    }
}

export default PerformanceFiltersMobile;
